import React from "react";
import "./Box3.css";
import img from "../../../assets/box3.jpg";

const Box3 = () => {
  return (
    <div className="box-2-snaithe-main-info">
      <div className="image-container-right-1-3-custom">
        <img src={img} alt="Square Image" />
      </div>
      <div className="text-container-3-custom">
        <div className="title-3-custom">Snáithe</div>
        <h2 className="box3-second-titles-3-custom">
          Merging Trust, Forging Excellence
        </h2>
        <div className="text-3-custom1">
          At the nucleus of our intricate tapestry of brands resides Snáithe –
          the quintessence of trust, dependability, and steadfast commitment.
          Snáithe stands as the North Star, diligently ensuring each brand
          within its fold maintains an unwavering trajectory of peak performance
          and unwavering responsibility. It transcends being a mere moniker;
          it's an incontrovertible guarantee, an emblem of authenticity that
          profoundly resonates with individuals across the spectrum. Our journey,
          commencing in 1992, stands as an enduring testament to the power of
          unity, where a consortium of brands converges, each contributing a
          unique hue to the canvas of excellence that Snáithe fervently embodies.
          From shaping the course of mobility's future to crafting spaces that
          radiate elegance, Snáithe orchestrates a symphonic fusion of
          innovation and dedication. Embarking on a journey with Snáithe means
          embracing trust, excellence, and a commitment to boundless fulfillment.
        </div>
      </div>
    </div>
  );
};

export default Box3;
